import { createFileRoute } from "@tanstack/react-router";

import { McpClientPage } from "@/components/Mcp/McpClientPage";
import { getMcpClient } from "@/components/Mcp/mcpClients";
import { mcpClientHead } from "@/components/Mcp/mcpHead";

const client = getMcpClient("windsurf");

export const Route = createFileRoute("/mcp/windsurf")({
  component: () => <McpClientPage client={client} />,
  head: () => mcpClientHead(client),
});
